import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://ybagtdqycyceouhynqzk.supabase.co";
const supabaseAnonKey = "sb_publishable_8TY6V0pVKl2bsBIZjGPxKw_rlcCr3ca";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
